<template>
	<div>
		<!-- Video Element -->
		<div
		v-if="status ==='preview'"
		:preventActiveBehavior="true"
		:parent="false">
		<div>
			<div class="element-position">
				<div v-if="content.url" style="position: absolute; width: 178vh; top: 400px; left: 800px; color: pink;" class="absolute">
					<music-icon v-if="!filteredLyric" :style="style" :size="300"></music-icon>
				</div>
				<div class="text-center w-100 color-white" v-if="!isAudiLoading && isAudio && status ==='preview'">
				</div>
				<audio
					:loop="isLoop"
					ref="audioPreview"
					@timeupdate="getCurrentTime"
				>
				</audio>
				<!-- lyric component preview -->
				<div ref="audioLyricsPreview" class="rabbit-lyrics" :style="bgLyric" style="max-height: 17vh; min-width: 100%; position: fixed; bottom:0; overflow-y: hidden;">
					{{filteredLyric}}
				</div>
			</div>
		</div>
		</div>
		<!-- Video Element -->
		<div v-if="status ==='live' && isAudio">
			<div class="text-center top-50p w-100 color-white" v-if="!isAudiLoading && isAudio && status ==='live'">
			</div>
			<div class="element-position" v-if="status ==='live' && isAudio">
				<audio
					controls
					:id="audioId"
					:loop="isLoop"
					@timeupdate="getCurrentTime"
					ref="audioLive">
				</audio>
				<!-- lyric component live -->
				<div ref="audioLyricsLive" class="rabbit-lyrics" :style="bgLyric" style="max-height: 17vh; min-width: 100%; position: fixed; bottom:0; overflow-y: hidden;">
					{{filteredLyric}}
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import localforage from 'localforage';
import MusicIcon from 'vue-material-design-icons/Music.vue';
// eslint-disable-next-line
import RabbitLyrics from '@/lib/lyric.js';
import {
	fontOptions,
} from '@/lib/statics';
import rundownItemsApi from '@/api/rundownItems';
import { duplicateVar, delay } from '@/lib/helper';

export default {
	name: 'ElementAudio',
	components: {
		MusicIcon,
	},
	props: {
		item: {
			type: Object,
		},
		status: {
			type: String,
		},
		delay: {},
	},
	data() {
		return {
			isAudiLoading: false,
			localMute: false,
			localMutePreview: false,
			localItem: null,
			fontOptions,
		};
	},

	sockets: {
		connect() {
			// this.activateSocket();
		},
		async items_live_update(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				if (this.localItem.id === item.id) {
					const muted = this.content && this.content.muted ? this.content.muted : false;
					this.localMute = muted;
					// const checkLivePlaying = !!(item.is_play_live && this.status === 'preview');
					this.localMutePreview = true;
					// mute preview if play live
					if (item.is_play_live) this.$refs.audioPreview.muted = true;
					if (this.$refs.audioPreview && !item.is_play_live && !this.localMute) this.$refs.audioPreview.muted = false;
					// trigger fadeout audio
					if (this.item && this.item.id === item.id && !item.is_play_live && this.$route.name !== 'DisplayLive') this.fadeout();
					// trigger fadeout audio on displayLive (its different bcz had delay)
					// eslint-disable-next-line
					await this.sleep(this.delay);
					if (this.item && this.item.id === item.id && !item.is_play_live && this.$route.name === 'DisplayLive') {
						this.fadeout();
					}
				}
			}
		},
		items_preview_update(items) {
			for (let index = 0; index < items.length; index++) {
				const item = items[index];
				// trigger fadeout audio
				if (this.item && this.item.id === item.id && !item.is_play_preview) this.fadeout();
			}
		},
		force_play_item(data) {
			if (this.localItem.id === data.id) {
				this.localItem = duplicateVar(data);
				this.setAudioTime();
				this.isAudiLoading = false;
				const isAudio = this.localItem.type === 'audio';
				this.$nextTick(() => {
					localforage.getItem(`audio_${this.content.id}`, (err, value) => {
						if (!err && value) {
							const mediaSource = URL.createObjectURL(value);
							if (isAudio) {
								const audioLive = this.$refs.audioLive;
								const audioPreview = this.$refs.audioPreview;
								if (this.status === 'live' && audioLive) {
									this.$refs.audioLive.src = `${mediaSource}#t=${this.inPoint},${this.outPoint}`;
									this.$refs.audioLive.volume = this.volumeAudio / 100;
									this.$refs.audioLive.muted = this.isMuted;
									this.$refs.audioLive.play();
								}
								if (this.status === 'preview' && audioPreview) {
									this.$refs.audioPreview.src = `${mediaSource}#t=${this.inPoint},${this.outPoint}`;
									this.$refs.audioPreview.volume = this.volumeAudio / 100;
									this.$refs.audioPreview.muted = this.isPreviewMuted;
									this.$refs.audioPreview.play();
								}
							}
						} else {
							// eslint-disable-next-line no-lonely-if
							if (isAudio) {
								const audioLive = this.$refs.audioLive;
								const audioPreview = this.$refs.audioPreview;
								if (this.status === 'live' && audioLive) {
									this.$refs.audioLive.src = `${this.content.url}#t=${this.inPoint},${this.outPoint}`;
									this.$refs.audioLive.volume = this.volumeAudio / 100;
									this.$refs.audioLive.muted = this.isMuted;
									this.$refs.audioLive.play();
								}
								if (this.status === 'preview' && audioPreview) {
									this.$refs.audioPreview.src = `${this.content.url}#t=${this.inPoint},${this.outPoint}`;
									this.$refs.audioPreview.volume = this.volumeAudio / 100;
									this.$refs.audioPreview.muted = this.isPreviewMuted;
									this.$refs.audioPreview.play();
								}
							}
						}
					});
				});
			}
		},
		item_mute_update(data) {
			const status = data.status;
			const id = data.id;
			if (this.localItem.id === id) {
				const propsMuted = JSON.parse(status);
				this.localMute = propsMuted;
			}
		},
	},
	methods: {
		sleep(ms) {
			return new Promise(
				resolve => setTimeout(resolve, ms),
			);
		},
		hasProperty(obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		activateSocket() {
			// this.$socket.client.emit('join', this.room);
		},
		setAudioTime() {
			if (this.status === 'live' && this.$refs.audioLive) {
				this.$refs.audioLive.currentTime = this.playTime;
			}
			if (this.status === 'preview' && this.$refs.audioPreview) {
				this.$refs.audioPreview.currentTime = this.playTime;
			}
		},
		onStoAudio() {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			if (this.status === 'live') {
				localStorage.removeItem(`item_duration_${this.localItem.id}`);
				rundownItemsApi.stopLive(this.localItem.id, callback, errorCallback);
			}
			if (this.status === 'preview') {
				rundownItemsApi.stopAll(this.localItem.id, this.status, callback, errorCallback); // stop the lower third automatically
			}
		},
		onCompletePlay(itemId) {
			const callback = () => {
			};
			const errorCallback = () => {
			};
			rundownItemsApi.playLive(itemId, callback, errorCallback);
		},
		fadeout() {
			let decreaser = 0.1;
			if (this.$refs.audioPreview && (this.$refs.audioPreview.volume > 0)) {
				const resultDecreaser = this.$refs.audioPreview.volume - decreaser;
				if (resultDecreaser > 0) this.$refs.audioPreview.volume = resultDecreaser;
				decreaser = +0.1;
			}
			if (this.$refs.audioLive && (this.$refs.audioLive.volume > 0)) {
				const resultDecreaser = this.$refs.audioLive.volume - decreaser;
				if (resultDecreaser > 0) this.$refs.audioLive.volume = resultDecreaser;
				decreaser = +0.1;
			}
			setTimeout(this.fadeout, 100);
		},
		getCurrentTime() {
			if (this.$refs.audioPreview) {
				const resultDecreaser = this.outPoint - this.$refs.audioPreview.currentTime;
				if (resultDecreaser <= 1 && resultDecreaser >= 0.8 && !this.isLoop) this.fadeout();
			}
			if (this.$refs.audioLive) {
				const resultDecreaser2 = this.outPoint - this.$refs.audioLive.currentTime;
				if (resultDecreaser2 <= 1 && resultDecreaser2 >= 0.8 && !this.isLoop) this.fadeout();
			}
		},
	},
	computed: {
		audioId() {
			return `audio-${this.localItem.id}`;
		},
		content() {
			return this.localItem.content && this.localItem.content !== ''
				? JSON.parse(this.localItem.content) : {};
		},
		isLoop() {
			return this.content.loop;
		},
		isAudio() {
			return this.content && this.content.type === 'audio';
		},
		isPreviewMuted() {
			return this.localMutePreview;
		},
		isMuted() {
			return this.localMute;
		},
		volumeAudio() {
			return this.content && this.content.volume ? this.content.volume : 100;
		},
		playTime() {
			return this.localItem && this.localItem.play_time ? this.localItem.play_time : 0;
		},
		inPoint() {
			const hms = this.content.inPoint;// your input string
			const a = hms.split(':'); // split it at the colons
			const seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
			return seconds;
		},
		outPoint() {
			const hms = this.content.outPoint;// your input string
			const a = hms.split(':'); // split it at the colons
			let seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);
			const originDuration = Math.floor(this.content.duration);
			if (seconds === parseInt(originDuration)) seconds = this.content.duration;
			return seconds;
		},
		style() {
			const style = {};
			style.position = 'absolute';
			style.zIndex = this.localItem.layer_index;
			return style;
		},
		filteredLyric() {
			const lyrics = this.content && this.content.extractedLyric !== '' ? this.content.extractedLyric : '';
			return lyrics;
		},
		fontStyle() {
			const indexFont = this.content && this.content.fontStyle ? this.content.fontStyle : 0;
			return this.fontOptions[indexFont].label;
		},
		fontColor() {
			return this.content && this.content.color ? this.content.color : '#FFFFFFFF';
		},
		bgColor() {
			return this.content && this.content.backgroundColor ? this.content.backgroundColor : '#2c2a2a52';
		},
		bgLyric() {
			return {
				'--bg-color': this.bgColor,
				'--font-color': this.fontColor,
				'--font-style': `'${this.fontStyle}'`,
				'--sec-color': `${this.fontColor.substring(0, this.fontColor.length - 2)}66`,
			};
		},
	},
	watch: {
		item() {
			if (this.item) {
				this.localItem = this.item;
				if (this.item.is_hidden) {
					const callback = () => {
						// insert your function here
						// this.isShowModalConfirnMuted = false;
					};
					const errCallback = () => {
						// insert your function here
						// this.isShowModalConfirnMuted = false;
					};
					const params = {
						id: this.item.id || null,
						status: true,
					};
					rundownItemsApi.mute(params.id, params.status, callback, errCallback);
				} else {
					const callback = () => {
						// insert your function here
						// this.isShowModalConfirnMuted = false;
					};
					const errCallback = () => {
						// insert your function here
						// this.isShowModalConfirnMuted = false;
					};
					const params = {
						id: this.item.id || null,
						status: false,
					};
					rundownItemsApi.mute(params.id, params.status, callback, errCallback);
				}
			}
		},
	},
	created() {
		this.localItem = this.item;
		const muted = this.content && this.content.muted ? this.content.muted : false;
		this.localMute = muted;
		// const checkLivePlaying = !!(this.localItem.is_play_live && this.status === 'preview');
		if (this.localItem.is_play_live) {
			this.localMutePreview = true;
		} else {
			if (!this.localItem.is_play_live && muted) this.localMutePreview = true;
			if (!this.localItem.is_play_live && !muted) this.localMutePreview = false;
		}
		// this.activateSocket();
	},
	beforeDestroy() {
		this.localMutePreview = false;
		this.localMute = false;
		delay(() => {
			if (this.status === 'live' && this.$refs.audioLive) {
				this.$refs.audioLive.src = '';
			}
			if (this.status === 'preview' && this.$refs.audioPreview) {
				this.$refs.audioPreview.src = '';
			}
		}, 500);
	},
	mounted() {
		if (this.$refs.audioLyricsPreview) {
			// eslint-disable-next-line
			new RabbitLyrics({
				element: this.$refs.audioLyricsPreview,
				mediaElement: this.$refs.audioPreview,
				viewMode: 'full',
			});
		}
		if (this.$refs.audioLyricsLive) {
			// eslint-disable-next-line
			new RabbitLyrics({
				element: this.$refs.audioLyricsLive,
				mediaElement: this.$refs.audioLive,
				viewMode: 'full',
			});
		}
		this.setAudioTime();
		this.isAudiLoading = false;
		const isAudio = this.localItem.type === 'audio';
		if (this.status === 'live' && isAudio) {
			const detectVideoDone = this.$refs.audioLive;
			const detectVideo = this.$refs.audioLive;
			detectVideoDone.addEventListener('ended', this.onStoAudio, false);

			// play with range
			detectVideo.addEventListener('timeupdate', () => {
				if (detectVideo.currentTime.toFixed(0) === (this.outPoint.toFixed(0))) {
					if (!this.isLoop) {
						const callback = () => {
						};
						const errorCallback = () => {
						};
						localStorage.removeItem(`item_duration_${this.localItem.id}`);
						rundownItemsApi.stopLive(this.item.id, callback, errorCallback);
						if (this.content && this.content.onCompleteItem) {
							this.onCompletePlay(this.content.onCompleteItem);
						}
					} else {
						detectVideo.currentTime = this.inPoint;
					}
				}
			});
		}
		if (this.status === 'preview' && isAudio) {
			const detectVideoDone = this.$refs.audioPreview;
			const detectVideo = this.$refs.audioPreview;
			detectVideoDone.addEventListener('ended', this.onStoAudio, false);
			// play with range
			detectVideo.addEventListener('timeupdate', () => {
				if (detectVideo.currentTime.toFixed(0) === (this.outPoint.toFixed(0))) {
					if (!this.isLoop) {
						const callback = () => {
						};
						const errorCallback = () => {
						};
						rundownItemsApi.stopAll(this.localItem.id, this.status, callback, errorCallback);
					} else {
						detectVideo.currentTime = this.inPoint;
					}
				}
			});
		}
		this.$nextTick(() => {
			localforage.getItem(`audio_${this.content.id}`, (err, value) => {
				if (!err && value) {
					const mediaSource = URL.createObjectURL(value);
					if (isAudio) {
						const audioLive = this.$refs.audioLive;
						const audioPreview = this.$refs.audioPreview;
						if (this.status === 'live' && audioLive) {
							this.$refs.audioLive.src = `${mediaSource}#t=${this.inPoint},${this.outPoint}`;
							this.$refs.audioLive.volume = this.volumeAudio / 100;
							this.$refs.audioLive.muted = this.isMuted;
							this.$refs.audioLive.play();
						}
						if (this.status === 'preview' && audioPreview) {
							this.$refs.audioPreview.src = `${mediaSource}#t=${this.inPoint},${this.outPoint}`;
							this.$refs.audioPreview.volume = this.volumeAudio / 100;
							this.$refs.audioPreview.muted = this.isPreviewMuted;
							this.$refs.audioPreview.play();
						}
					}
				} else {
					// eslint-disable-next-line no-lonely-if
					if (isAudio) {
						const audioLive = this.$refs.audioLive;
						const audioPreview = this.$refs.audioPreview;
						if (this.status === 'live' && audioLive) {
							this.$refs.audioLive.src = `${this.content.url}#t=${this.inPoint},${this.outPoint}`;
							this.$refs.audioLive.volume = this.volumeAudio / 100;
							this.$refs.audioLive.muted = this.isMuted;
							this.$refs.audioLive.play();
						}
						if (this.status === 'preview' && audioPreview) {
							this.$refs.audioPreview.src = `${this.content.url}#t=${this.inPoint},${this.outPoint}`;
							this.$refs.audioPreview.volume = this.volumeAudio / 100;
							this.$refs.audioPreview.muted = this.isPreviewMuted;
							this.$refs.audioPreview.play();
						}
					}
				}
			});
		});
	},
};
</script>

<style>
	.rabbitLyrics {
		background-color: var(--bg-color);
		text-align: center;
		font-size: 4vh;
		color: var(--sec-color);
		margin: 0px;
		font-family: var(--font-style);
	}

	.rabbitLyricsLineActive {
		padding-top: 30px;
		color:var(--font-color);
		font-size: 6vh;
		font-family: var(--font-style);
	}

	.rabbitLyricsLine {
		min-height: 0em;
	}
</style>
